import RentalIncome from "./RentalIncome";

export default RentalIncome;
